export default __webpack_public_path__ + "static/media/mute.0e67eec1.png";